var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var EditIcon = function (props) {
    var _a = props.width, width = _a === void 0 ? 15 : _a, _b = props.height, height = _b === void 0 ? 15 : _b, editIconProps = __rest(props, ["width", "height"]);
    return (_jsx("svg", __assign({ width: width, height: height, viewBox: '0 0 15 15', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, editIconProps, { children: _jsx("path", { d: 'M8.60222 5.18222L9.31778 5.89778L2.27111 12.9444H1.55556V12.2289L8.60222 5.18222ZM11.4022 0.5C11.2078 0.5 11.0056 0.577778 10.8578 0.725556L9.43444 2.14889L12.3511 5.06556L13.7744 3.64222C14.0778 3.33889 14.0778 2.84889 13.7744 2.54556L11.9544 0.725556C11.7989 0.57 11.6044 0.5 11.4022 0.5ZM8.60222 2.98111L0 11.5833V14.5H2.91667L11.5189 5.89778L8.60222 2.98111Z', fill: 'currentColor' }) })));
};
